import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

function BuscarTransferenciasPorFecha({ onTransferenciasFiltradas ,fechaInicio,fechaFin,setFechaInicio,setFechaFin}) {

  const [cargando, setCargando] = useState(false); 
  const handleBuscar = async (e) => {
    e.preventDefault();
  
    setCargando(true);
  
    try {
      await onTransferenciasFiltradas(
        1,
        fechaInicio || undefined,
        fechaFin || undefined
      );
    } finally {
      setCargando(false);
    }
  };
  return (
    <Form onSubmit={handleBuscar} className="d-flex align-items-center">
      <InputGroup className="input-group-sm me-2">
        <span className="input-group-text">Inicio:</span>
        <Form.Control
          type="date"
          value={fechaInicio}
          onChange={(e) => setFechaInicio(e.target.value)}
          required
          className="form-control"
          style={{ minWidth: '150px' }}
        />
        <span className="input-group-text">Fin:</span>
        <Form.Control
          type="date"
          value={fechaFin}
          onChange={(e) => setFechaFin(e.target.value)}
          required
          className="form-control"
          style={{ minWidth: '150px' }}
        />
        <Button type="submit" className="btn btn-primary custom-button d-flex align-items-center">
          {cargando ? 'Buscando...' : <><FaSearch className="me-1" /> Buscar</>}
        </Button>
      </InputGroup>
    </Form>
  );
}

export default BuscarTransferenciasPorFecha;
